import Home from '../views/Home.vue'
import { Role } from '../helpers/role'
import Router from 'vue-router'
import Vue from 'vue'
import administrationRoutes from './administration.routes'
import annualCatalogRoutes from './annualCatalog.routes'
import authRoutes from './auth.routes'
import auxiliaryRegisterRoutes from './auxiliaryRegister.routes'
import financeRoutes from './finance.routes'
import formsRoutes from './forms.routes'
import planning from './planning'
import proposalRoutes from './proposals.route'
import registersRoutes from './registers.routes'
import reportDataRoutes from './reportData.routes'
import store from '../store/store'

Vue.use(Router);

const routes = [
    ...authRoutes,
    ...administrationRoutes,
    ...registersRoutes,
    ...formsRoutes,
    ...financeRoutes,
    ...annualCatalogRoutes,
    ...planning,
    ...proposalRoutes,
    ...reportDataRoutes,
    ...auxiliaryRegisterRoutes,
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            title: 'sideMenu.home'
        }
    },
    {
        path: '/dynamiclayout',
        name: 'dynamicLayout',
        component: () => import('../views/DynamicLayout.vue'),
        meta: {
            title: 'dynamicLayout.homePageLayout'
        }
    },
    {
        path: '/account/:id?',
        name: 'account',
        component: () => import('../views/account/Account.vue'),
        meta: {
            title: 'account.title'
        },
         props: (route) => ({ eventId: route.query.eventId })
    },
    {
        path: '/logs',
        name: 'logs',
        component: () => import('../views/account/Logs.vue'),
        meta: {
            title: 'account.logs'
        }
    },
    {
        path: '/administration/logs',
        name: 'allLogs',
        component: () => import('../views/account/Logs.vue'),
        props: (route) => ({ all: true }),
        meta: { claims: [{ name: 'audit', crud: 'read' }], title: 'account.logs' },
    },
    {
        path: '/calendar',
        name: 'calendar',
        component: () => import('../views/calendar/Calendar.vue'),
        props: (route) => ({ viewType: 'month' }),
        meta: { claims: [{ name: 'calendar', crud: 'read' }] }
    },
    {
        path: '/hallsCalendar',
        name: 'hallsCalendar',
        component: () => import('../views/scheduler/HallEventScheduler.vue'),
        props: (route) => ({ viewType: 'workWeek' }),
        meta: { claims: [{ name: 'agenda', crud: 'read' }], title: 'scheduler.calendar' }
    },
    {
        path: '/hallAgenda',
        name: 'hallAgenda',
        component: () => import('../views/scheduler/HallAgenda.vue'),
        meta: { claims: [{ name: 'agenda', crud: 'read' }], title: 'scheduler.agenda' }
    },
    {
        path: '/tasks',
        name: 'tasks',
        component: () => import('../views/tasks/Tasks.vue'),
        meta: {
            title: 'sideMenu.tasks',
            titleDescription: '',
            claims: [{ name: 'tasks', crud: 'read' }]
        }
    },
    {
        path: '/coordinations',
        name: 'coordinations',
        component: () => import('../views/tasks/Coordinations.vue'),
        meta: {
            title: 'sideMenu.coordinations',
            titleDescription: '',
            claims: [{ name: 'tasks', crud: 'read' }]
        }
    },
    {
        path: '/signatures',
        name: 'signatures',
        component: () => import('../views/tasks/Signatures.vue'),
        meta: {
            title: 'sideMenu.signing',
            titleDescription: '',
            claims: [{ name: 'tasks', crud: 'read' }]
        }
    },
    {
        path: '/signingProcedureFiling',
        name: 'signingProcedureFiling',
        component: () => import('../views/tasks/SigningProcedureFilingList.vue'),
        meta: {
            title: 'sideMenu.signingProcedureFiling',
            titleDescription: '',
            claims: [{ name: 'signingProcedureFiling', crud: 'read' }]
        }
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('../views/test/Ranking.vue'),
        meta: {}
    },
    {
        path: '/test1',
        name: 'test1',
        component: () => import('../views/test/TempRankingPendingConfirmation.vue'),
        meta: {}
    },
    {
        path: '/test2',
        name: 'test2',
        component: () => import('../views/test/TempRankingConfirmationList.vue'),
        meta: {}
    },
    {
        path: '/test3',
        name: 'test3',
        component: () => import('../views/scheduler/HallEventScheduler.vue'),
        meta: { authorize: [Role.Nip] }
    },
    {
        path: '/hallsUnderConstruction',
        name: 'placesSchedulerUnderConstruction',
        component: () => import('../views/registers/places/SchedulerUnderConstruction.vue'),
        meta: { authorize: [Role.Admin] }
    },
    {
        path: '/presenceForm',
        name: 'presenceForm',
        component: () => import('../components/administration/PresenceForm.vue'),
        meta: { title: 'sideMenu.presenceForm', claims: [{ name: 'presence', crud: 'read' }] }
    },
    {
        path: '/documentsRelation',
        name: 'allDocuments',
        component: () => import('../views/administration/DocumentsRelation.vue'),
        meta: { title: 'sideMenu.documents', claims: [{ name: 'documents', crud: 'read' }] }
    },
    {
        path: '/certificates',
        name: 'certificates',
        component: () => import('../views/certificates/CertificatesListView.vue'),
        meta: { title: 'sideMenu.certificates', claims: [] }
    },
    {
        path: '/help',
        name: 'help',
        component: () => import('../views/Help.vue'),
        props: () => ({ editMode: false }),
        meta: { title: 'help.title' }
    },
    {
        path: '/help/edit',
        name: 'helpEdit',
        component: () => import('../views/Help.vue'),
        props: () => ({ editMode: true }),
        meta: { title: 'help.title' }
    },
    {
        path: '/localServer',
        name: 'LocalServer',
        component: () => import('@/views/LocalServer.vue'),
        meta: { title: 'localServer.title' }
    },
]

export const router = new Router({
    routes: routes
});

router.beforeEach((to, from, next) => {
    const { authorize, claims } = to.meta;

    Vue.cookie.delete('ReportServerCookie');

    if (!store.getters.isAuthenticated) {
        const freePaths = ['/login', '/register', '/login/result', '/resetPassword', '/registers/publicOrders/publicList', `/registers/publicOrder/${to.params.id}/details`, `/lecturersElRegister`,
            `/forms/complete`, `/forms/entryEdit`
        ]

        if (freePaths.includes(to.path)) {
            next();
            return;
        } else {
            if (to.path.includes('login')) {
                next()
            } else {
                const returnUrl = to.fullPath;
                if (returnUrl && returnUrl.indexOf('login') > -1) {
                    next(`/login`); // returnUrl от към login. получава се зацикляна
                } else {
                    next(`/login?returnUrl=${to.fullPath}`);
                }
            }
            return;
        }
    } else {
		next();
    }

    if (authorize || (claims && claims.length)) {
        // The route needs authorization
        let isUserInRole = false;
        if (authorize) {
            const userRoles = store.getters.userRoles;
            userRoles.forEach((userRole) => {
                if (authorize.includes(userRole)) {
                    isUserInRole = true;
                }
            })
        }

        let hasClaim = false;
        if (claims) {
            hasClaim = claims.some((claim) => {
                return store.getters.claims[claim.name][claim.crud] === true;
            });
        }

        if (!isUserInRole && !hasClaim) {
            next('/unauthorized');
        }
    }
})
